/**
 * Sanitisation du HTML des emails pour éviter XSS.
 * À utiliser partout où du HTML email est injecté (body, preview, etc.).
 */
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'div', 'span', 'a', 'strong', 'b', 'em', 'i', 'u', 's', 'ul', 'ol', 'li',
  'table', 'thead', 'tbody', 'tr', 'th', 'td', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'img', 'blockquote', 'pre', 'code', 'hr', 'sub', 'sup',
];
const ALLOWED_ATTR = ['href', 'target', 'rel', 'src', 'alt', 'title', 'style', 'class', 'width', 'height'];

export function sanitizeHtml(dirty) {
  if (typeof dirty !== 'string') return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ADD_ATTR: ['target', 'rel'],
    ALLOW_DATA_ATTR: false,
  });
}
